import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
} from '@mui/material';
import { Email, Phone, LocationOn } from '@mui/icons-material';
import useScrollToSection from '../utils/useScrollToSection';

import {
  footerContainer,
  logoBox,
  logoImage,
  linkItem,
  contactItem,
  iconStyle,
  dividerStyle,
  copyrightStyle
} from '../styles/Footer';

import {
  FOOTER_LOGO,
  FOOTER_SLOGAN,
  FOOTER_BRAND,
  QUICK_LINKS
} from '../data/Footer';

import {
  PHONE,
  EMAIL,
  LOCATION,
  PHONE_LINK,
  EMAIL_LINK,
  MAP_LINK
} from '../data/Contact';

const Footer = () => {
  const scrollToSection = useScrollToSection();

  return (
    <Box component="footer" sx={footerContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start">
          
          {/* Branding */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Box sx={logoBox}>
              <Box component="img" src={FOOTER_LOGO} alt="Safinah Al Sama Logo" sx={logoImage} />
              <Typography variant="h6" sx={{ fontWeight: 900 }}>
                {FOOTER_BRAND}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {FOOTER_SLOGAN}
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Quick Links
            </Typography>
            {QUICK_LINKS.map(({ name, id }) => (
              <Link
                key={id}
                component="button"
                onClick={() => scrollToSection(id)}
                underline="hover"
                color="text.secondary"
                variant="body2"
                sx={linkItem}
              >
                {name}
              </Link>
            ))}
              <Link
                href='/privacy-policy'
                underline="hover"
                color="text.secondary"
                variant="body2"
                sx={linkItem}
              >
                Privacy Policy
            </Link>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Contact Information
            </Typography>

            <Box component="a" href={PHONE_LINK} sx={contactItem}>
              <Phone sx={iconStyle} fontSize="small" />
              <Typography variant="body2">{PHONE}</Typography>
            </Box>

            <Box component="a" href={EMAIL_LINK} sx={contactItem}>
              <Email sx={iconStyle} fontSize="small" />
              <Typography variant="body2">{EMAIL}</Typography>
            </Box>

            <Box component="a" href={MAP_LINK} target="_blank" rel="noopener noreferrer" sx={contactItem}>
              <LocationOn sx={{ ...iconStyle, mt: 0.3 }} fontSize="small" />
              <Typography variant="body2">{LOCATION}</Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={dividerStyle} />

        <Typography variant="body2" color="text.secondary" align="center" sx={copyrightStyle}>
          © {new Date().getFullYear()} {FOOTER_BRAND}. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
